module.exports = __webpack_public_path__ + "assets/img/12.cd55b78b.png";